export default __webpack_public_path__ + "static/roadmap_last-063ec139865b5bcc6bb15f147b78f8e1.png";